import { useEffect, useState } from 'react'

import { getLocalPosition } from '../utils'

export const useLocalPosition = () => {
  const { x: localX, y: localY } = getLocalPosition()
  const [currentPosition, setCurrentPosition] = useState({ x: localX, y: localY })

  useEffect(() => {
    const onChange = (e) => {
      if (e.key !== 'gsg-btn-position_x' && e.key !== 'gsg-btn-position_y') return

      const { x, y } = getLocalPosition()
      setCurrentPosition({ x, y })
    }

    window.addEventListener('storage', onChange)

    return () => {
      window.removeEventListener('storage', onChange)
    }
  }, [])

  return currentPosition
}
